import { makeStyles } from '@material-ui/core/styles'
import { calcMargin } from '@v4/utils/theme'

const useStyles = makeStyles(
	theme => ({
		bgSection: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			height: '100%',
			bottom: 0,
			overflow: 'hidden',
			zIndex: 1,
		},
		bgContainer: {
			height: '100%',
			[theme.breakpoints.down('sm')]: {
				padding: 0,
			},
		},
		bgGrid: {
			height: '100%',
		},
		background: {
			backgroundColor: 'lightgray',
			width: '100%',
			height: theme.spacing(50),
			overflow: 'hidden',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',

			[theme.breakpoints.up('md')]: {
				height: '100%',
			},
		},
		withVideo: {
			cursor: 'pointer',
		},
		icon: {
			fontSize: theme.spacing(6.8),
			color: '#fff',
		},
		content: {
			position: 'relative',
			zIndex: 2,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'center',
			transition: theme.transitions.create(['padding-top', 'padding-bottom']),
			paddingTop: ({ metaData, isMobile, minMargins }) => {
				if (!isMobile || !metaData.mobileImagePosition?.isLeftAlignment) {
					return null
				}
				const marginMeta = metaData.overrideXsMargins?.toBoolean() ? metaData.xsMarginTop : metaData.marginTop

				return calcMargin({
					spacing: theme.spacing,
					value: marginMeta?.metaValue,
					minMargin: minMargins.top,
					isMobile: true,
				})
			},
			paddingBottom: ({ metaData, isMobile, minMargins }) => {
				if (!isMobile || !metaData.mobileImagePosition?.isRightAlignment) {
					return null
				}

				const marginMeta = metaData.overrideXsMargins?.toBoolean()
					? metaData.xsMarginBottom
					: metaData.marginBottom

				return calcMargin({
					spacing: theme.spacing,
					value: marginMeta?.metaValue,
					minMargin: minMargins.bottom,
					isMobile: true,
				})
			},

			[theme.breakpoints.up('md')]: {
				paddingLeft: ({ metaData }) => (metaData.videoPosition?.isRightAlignment ? null : theme.spacing(8)),
			},
		},

		textWrapper: {
			width: '100%',
			maxWidth: theme.spacing(59),

			[theme.breakpoints.down('sm')]: {
				maxWidth: '100%',
			},
		},

		text: {
			marginBottom: theme.spacing(3),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},

		buttonsWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'flex-start',
			flexWrap: 'wrap',

			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
				alignItems: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},

		button: {
			width: 'auto',
			marginBottom: theme.spacing(3),
			marginRight: theme.spacing(2),

			[theme.breakpoints.down('xs')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
				marginBottom: theme.spacing(3),
				marginRight: 0,
			},
		},

		additionalButton: {
			marginRight: ({ metaData }) => (metaData.videoPosition?.isRightAlignment ? null : 0),

			[theme.breakpoints.down('xs')]: {
				marginRight: 0,
			},
		},

		modal: {
			backgroundColor: 'transparent',
			boxShadow: 'none',
			width: '100%',
			overflowY: 'visible',
		},
	}),
	{ name: 'Banners-Banner13' },
)

export default useStyles
